var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$temAcessoView('CTRLACS-APP-02'))?_c('span',{staticClass:"text-primary mr-2"},[_c('i',{staticClass:"fa fa-info-circle fa-lg icon-button",attrs:{"title":"Detalhar"},on:{"click":function($event){$event.stopPropagation();return _vm.detalhar()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }